export default class ReportsNavService {
  constructor(gettext) {
    'ngInject';

    let module = {
      id: 'reports',
      name: gettext('Analytics'),
      sref: 'reports',
      icon: 'far fa-chart-line',
      priority: 50,
      items: [
        {
          name: gettext('Business Insights'),
          sref: 'reports.list',
          group: 'analytics'
        },
        {
          name: gettext('Scheduled Reports'),
          sref: 'reports.jobschedules',
          group: 'analytics'
        },
        {
          name: gettext('Dashboards'),
          sref: 'reports.dashboards',
          group: 'analytics'
        }
      ],
      groups: [
        {
          id: 'analytics',
          name: gettext('Analytics')
        }
      ]
    };

    this.getModule = () => module;
  }
}
